import React from "react";
import { Bar, Bubble, Doughnut, Line, Pie, PolarArea, Radar, Scatter } from "react-chartjs-2";
// import zoomPlugin from 'chartjs-plugin-zoom';
import { getBoundingClientRect } from "../../utils/functions";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, registerables, LinearScale, Plugin } from "chart.js";
import { TreemapController, TreemapElement } from 'chartjs-chart-treemap';
import { WordCloudController, WordElement } from 'chartjs-chart-wordcloud';
import { BoxPlotController, BoxAndWiskers } from '@sgratzl/chartjs-chart-boxplot';
import { FunnelController, TrapezoidElement } from 'chartjs-chart-funnel';

import { useRef, useEffect } from "react";
import { checkTranslation, getObject, imageAddress, setObject, translate } from "../../utils/useful";
import HttpServices from "../../utils/Http.services";
import 'chartjs-adapter-moment'
import moment from "moment";
// import PackedBubbleChart from "./PackedBubbleChart";
import GaugeWidget from "../widgets/GaugeWidget";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { adminPages } from "../../variables/adminPages";
import Matrix from "./Matrix";
import TableViewer from "../TableViewer";
// import chroma from "chroma-js";
// import PieChartSkeleton from "./PieChartSkeleton";

// import * as Funnel from "chartjs-plugin-funnel";




ChartJS.register(ArcElement, Legend, CategoryScale);
ChartJS.register(...registerables);
ChartJS.register(TreemapController, TreemapElement);
ChartJS.register(WordCloudController, WordElement);
ChartJS.register(FunnelController, TrapezoidElement, LinearScale, CategoryScale);
ChartJS.register(BoxPlotController, BoxAndWiskers, LinearScale, CategoryScale);

ChartJS.register(ChartDataLabels);
// ChartJS.register(zoomPlugin);



class Chart extends React.Component {

    images = ['https://images.unsplash.com/photo-1519699047748-de8e457a634e?auto=format&fit=crop&q=80&w=2960&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', 'https://images.unsplash.com/photo-1558222218-b7b54eede3f3?auto=format&fit=crop&q=60&w=800&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTA4fHxwb3J0cmFpdHxlbnwwfHwwfHx8MA%3D%3D', 'https://images.unsplash.com/photo-1611695434398-4f4b330623e6?auto=format&fit=crop&q=80&w=2835&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', 'https://i.stack.imgur.com/iLyVi.png']

    state = {
        show: false,
        stacked: true,
        // type: 'time',
        // data: [],
        data: {
            labels: [
                // 'Standing costs', 'Running costs'
            ],

            datasets: [
               
            ]
          
        },


        chartOptions: {

          
            responsive: true,
            aspectRatio: 2 / 1,


           
        }


       

    }

   



    componentDidMount() {
        window.addEventListener('resize', this.getSize)
        this.getSize()
        // this.init()
        // Chart.register(zoom)
        // Bar.register(zoom)

    }


   

    componentDidUpdate(prevProps) {
        if (prevProps.width != this.props.width) {
            this.getSize()
            setTimeout(() => {
                this.getSize()
            }, 400);
        }

        if (prevProps.isDragging != this.props.isDragging) {
            this.getSize()
        }

        // console.log(this.props.data)
        // console.log(this.state.information)

        if (!this.props.isDragging && (this.props.data && (JSON.stringify(this.props.data) != JSON.stringify(this.state.information)))) {
            if (this.props.applet) {


                this.init()
            } else {
                this.waitForId(10)
            }


        }
    }
    waitForId = (tryTime) => {
        if (tryTime > 0) {
            if (this.props.applet) {
                this.init()
            } else {
                setTimeout(() => {

                    this.waitForId(tryTime - 1)
                }, 100);
            }
        }

    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.getSize)
    }

    getSize = () => {
        if (this.chartContainer) {
            let bound = getBoundingClientRect(this.chartContainer)

            this.setState({ show: false, height: bound.height, width: bound.width }, () => {
                this.setState({ show: true })
            })
        }
    }



    barPlaceholder = {
        id: 'barPlaceholder',
        beforeDatasetsDraw: (chartInstance) => {


            let ctx = chartInstance.ctx,
                width = chartInstance.chartArea?.right,
                height = chartInstance.chartArea?.bottom


            // console.log("###### ,", ctx)

            // console.log(chartInstance.chartArea)
            if (ctx) {

                // console.log("###### ,", chartInstance.data.datasets)


                chartInstance.data.datasets.forEach(function (dataset, datasetIndex) {
                    if (chartInstance.getDatasetMeta) {
                        let datasetMeta = chartInstance.getDatasetMeta(datasetIndex);

                        // console.log("######!! ,", datasetMeta)

                        if (datasetMeta?.data) {
                            datasetMeta.data.forEach(function (segment, segmentIndex) {
                                // console.log(segment)
                                var sheight = segment.height,
                                    sWidth = segment.width,

                                    posX = segment.tooltipPosition().x,
                                    posY = segment.tooltipPosition().y
                                // draw white background
                                ctx.save();
                                ctx.fillStyle = '#00000008';
                                ctx.fillRect((posX - sWidth / 2), 10, (sWidth), height - sheight - 10);
                                ctx.restore();
                            });
                        }
                    }
                });
            }

        }
    }



    imagePlugin = {
        id: 'imagePlugin',
        beforeDatasetsDraw: (chart, args, pluginOptions) => {
            const { ctx, data, scales: { x, y, width, height } } = chart


            // console.log(y)

            if (x) {
                ctx.save()

                // console.log(chart.scales)



                // ctx.drawImage(image, 0, y.getPixelForValue(0), 30, 30)

                x.ticks.forEach((tick, index) => {
                    // if (index < 1) {
                    let myx = x.getPixelForTick(index) - 12;
                    let myy = y.bottom + 10

                    const image = new Image()
                    // image.onload = function () {
                    ctx.save();
                    this.roundedImage(ctx, myx, myy, 26, 26, 14);
                    ctx.clip();
                    image.src = this.images[index]
                    // image.style = { borderRadius: '5px', overflow: 'hidden' }
                    // image.style.objectFit = "cover"

                    // ctx.drawImage(image, myx, myy, 26, 26);
                    this.drawImageProp(ctx, image, myx, myy, 26, 26)

                    ctx.restore();
                    // }
                    // }

                });
            }
        }
    }



    roundedImage = (ctx, x, y, width, height, radius) => {
        ctx.beginPath();

        ctx.arc((x + width / 2), (y + width / 2), width / 2, 0, Math.PI * 2, true);

        // ctx.lineTo(x + width - radius, y);
        // ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
        // ctx.lineTo(x + width, y + height - radius);
        // ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
        // ctx.lineTo(x + radius, y + height);
        // ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
        // ctx.lineTo(x, y + radius);
        // ctx.quadraticCurveTo(x, y, x + radius, y);
        ctx.closePath();
        // ctx.stroke();

    }



    drawImageProp = (ctx, img, x, y, w, h, offsetX, offsetY) => {

        // if (arguments.length === 2) {
        //     x = y = 0;
        //     w = ctx.canvas.width;
        //     h = ctx.canvas.height;
        // }

        // default offset is center
        offsetX = typeof offsetX === "number" ? offsetX : 0.5;
        offsetY = typeof offsetY === "number" ? offsetY : 0.5;

        // keep bounds [0.0, 1.0]
        if (offsetX < 0) offsetX = 0;
        if (offsetY < 0) offsetY = 0;
        if (offsetX > 1) offsetX = 1;
        if (offsetY > 1) offsetY = 1;

        var iw = img.width,
            ih = img.height,
            r = Math.min(w / iw, h / ih),
            nw = iw * r,   // new prop. width
            nh = ih * r,   // new prop. height
            cx, cy, cw, ch, ar = 1;

        // decide which gap to fill    
        if (nw < w) ar = w / nw;
        if (Math.abs(ar - 1) < 1e-14 && nh < h) ar = h / nh;  // updated
        nw *= ar;
        nh *= ar;

        // calc source rectangle
        cw = iw / (nw / w);
        ch = ih / (nh / h);

        cx = (iw - cw) * offsetX;
        cy = (ih - ch) * offsetY;

        // make sure source rectangle is valid
        if (cx < 0) cx = 0;
        if (cy < 0) cy = 0;
        if (cw > iw) cw = iw;
        if (ch > ih) ch = ih;

        // fill image in dest. rectangle
        ctx.drawImage(img, cx, cy, cw, ch, x, y, w, h);
    }


    drawImageScaled = (ctx, img, x, y, width, height) => {
        var canvas = ctx.canvas;
        var hRatio = canvas.width / img.width
        var vRatio = canvas.height / img.height
        var ratio = Math.min(hRatio, vRatio)
        var centerShift_x = x//(canvas.width - img.width * ratio) / 2
        var centerShift_y = y//(canvas.height - img.height * ratio) / 2

        // console.log(ratio, canvas.width, canvas.height)
        // ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, img.width, img.height,
            centerShift_x, centerShift_y, width, height);
    }

  



    init() {

        // console.log("INIT")
        if (!this.props.isDragging) {
            // console.log("INIT**")
            let data = { ...this.props.data }
            // console.log(data)
            this.setState({ information: data })
            let body = data
            // console.log(body)
            // this.setState({  data: [] }, () => {
            this.setState({ isLoading: true })

            if (!body.filter) {
                body.filter = {}
            }
            body.filter.applet = this.props.applet?._id ?? this.props.applet

            HttpServices.request("getChartInfo", body, (fetchResult, fetchError, status) => {
                // SocketServices.addTopic(this.state.topicId, this.props.data.thing, 'things', null, this.updateData)

                // console.log(fetchResult)
                this.setState({ isLoading: false })


                if (fetchError) { return }


                this.cleanDataForTable(fetchResult.info, data)

                // this.setState({ data: fetchResult.info })
            })

        } else if (this.props.currentData) {
            let currentData = this.props.currentData
            this.setState({ data: currentData.data, show: true }, () => {
                this.getSize()
            })

        }

        // })
    }



    cleanDataForTable = (info) => {


        let currentData = {}

        let labels = []
        let datasets = []
        let mainPromises = []

        let data = this.props.data
        let chartType = this.props.header?.information?.type ?? this.props.chartType
        // let chartStyle = this.props.header?.information?.style
        let groupBy = this.props.header?.information?.groupBy
        let timeUnit = this.props.header?.information?.timeUnit ?? 'year,month'

        // console.log("cleanDataForTable",chartType)

        let maxValue = this.props.header?.information?.maxValue

        let fields = []
        if (this.props.frame) {
            fields = adminPages[this.props.frame].headers
        }

        let colField
        let groupByField
        let valueField

        if (Array.isArray(fields)) {

            for (let i = 0; i < fields.length; i++) {
                const field = fields[i];

                if (data.x_axis && field.key == data.x_axis) {
                    colField = field
                }

                if (data.groupBy && field.key == data.groupBy) {
                    groupByField = field
                }

                if (data.value && field.key == data.value) {
                    valueField = field
                }

            }
        }

        // console.log(colField, groupByField, valueField)




        if (chartType == 'funnel' || chartType == 'gauge') {
            groupBy = false
        }

        if (chartType == 'matrix') {


            info.forEach((element, index) => {

                let colId = element._id?.col?._id ?? element._id?.col
                let colLabel = colId

                if (colField.type == 'SelectInput') {
                    colLabel = getObject(element._id?.col, colField.information?.fields?.title)
                }

                // let labelIndex = labels.indexOf(colLabel)
                // if (labelIndex == -1) {
                //     labels.push(colLabel)
                // }
                let newData = { value: element.value }
                setObject(newData, colField.key, element._id?.col)
                setObject(newData, groupByField.key, element._id?.groupBy)
                // console.log(newData)
                datasets.push(newData)
            })


        } else if (chartType == 'table') {


            info.forEach((element, index) => {

                let colId = element._id?.col?._id ?? element._id?.col
                // let colLabel = colId

                // if (colField.type == 'SelectInput') {
                //     colLabel = getObject(element._id?.col, colField.information?.fields?.title)
                // }

                // let labelIndex = labels.indexOf(colLabel)
                // if (labelIndex == -1) {
                //     labels.push(colLabel)
                // }
                let newData = { value: element.value }
                setObject(newData, colField.key, element._id?.col)
                // setObject(newData, groupByField.key, element._id?.groupBy)
                // console.log(newData)
                datasets.push(newData)
            })

            // console.log(datasets)


        } else if (chartType == 'boxPlot') {

            let color = this.getRandomColor()
            // let color1 = this.getRandomColor()
            info.forEach((element, index) => {

                let colId = element._id?.col?._id ?? element._id?.col
                let colLabel = colId

                if (colField.type == 'SelectInput') {
                    colLabel = getObject(element._id?.col, colField.information?.fields?.title)
                }

                let labelIndex = labels.indexOf(colLabel)
                if (labelIndex == -1) {
                    labels.push(colLabel)
                }
            });

            let oneData = {
                label: 'Dataset 1',
                // itemBackgroundColor: '#00000010',
                // itemBorderColor:'#eee',
                backgroundColor: color,
                borderColor: color,
                borderWidth: 1,
                outlierColor: '#999999',
                padding: 0,
                itemRadius: 0,
                coef: 0,
                // minStats:'whiskerMin',
                // outlierColor: 'transparent',


                data: [
                    // this.randomValues(100, 10, 100),
                    // this.randomValues(100, 0, 20),
                    // this.randomValues(100, 20, 70),
                    // this.randomValues(100, 60, 100),
                    // this.randomValues(40, 50, 100),
                    // this.randomValues(100, 60, 120),
                    // this.randomValues(100, 80, 100)
                ]
            }

            // {
            //     label: 'Dataset 2',
            //     backgroundColor: color1,
            //     borderColor: color1,
            //     borderWidth: 1,
            //     outlierColor: '#999999',
            //     padding: 10,
            //     itemRadius: 1.5,
            //     radius:10,
            //     data: [
            //       this.randomValues(100, 60, 100),
            //       this.randomValues(100, 0, 100),
            //       this.randomValues(100, 0, 20),
            //       this.randomValues(100, 20, 70),
            //       this.randomValues(40, 60, 120),
            //       this.randomValues(100, 20, 100),
            //       this.randomValues(100, 80, 100)
            //     ]
            //   }

            info.forEach((element, index) => {
                // element.detail = element.detail.sort(function (a, b) {
                //     return a - b;
                // })
                oneData.data.push([])
                element.detail.forEach((d, j) => {

                    if (j > 10 && j < 100) {
                        oneData.data[index].push(d)
                    }

                });

            })

            // console.log(oneData)
            // datasets.push(oneData)





        } else if (chartType == 'bubble' || chartType == 'scatter') {
            // labels.push("TEST")

            // info.forEach((element, index) => {
            //     let labelIndex = labels.indexOf(element._id?.col)
            //     if (labelIndex == -1) {
            //         labels.push(element._id?.col)
            //     }
            // });

            let oneData = {
                label: "First Dataset",
                backgroundColor: this.getRandomColor(),
                // borderDashOffset: 0.0,
                // borderJoinStyle: 'miter',
                // pointBorderColor: "rgba(75,192,192,1)",
                // pointBackgroundColor: "#fff",
                // pointBorderWidth: 1,
                // pointHoverRadius: 5,
                // pointHoverBackgroundColor: "rgba(153, 102, 155, 0.2)",
                // pointHoverBorderColor: "rgba(153, 102, 155, 1)",
                // pointHoverBorderWidth: 2,
                // pointRadius: 1,
                // pointHitRadius: 10,
                // backgroundColor: this.createColorArray(info),
                data: [],
                align: 'left',

            }


            info.forEach((element, index) => {

                let colId = element?._id?.col?._id ?? element?._id?.col
                let colLabel = colId

                if (colField.type == 'SelectInput') {
                    colLabel = getObject(element._id?.col, colField.information?.fields?.title)
                }

                oneData.data.push({
                    x: element.value,
                    y: element.value1,
                    label: colLabel,
                    value: element.value,

                    // r: element.value2 / 100,
                    // r: element.value2,

                })
                // let labelIndex = labels.indexOf(element._id?.col)
                // if (labelIndex != -1) {
                //     oneData.data[labelIndex] = element.value
                // }
            })

            // datasets= [{
            //     label: 'First Dataset',
            //     data: [{
            //         x: 20,
            //         y: 30,
            //         r: 15
            //     }, {
            //         x: 40,
            //         y: 10,
            //         r: 10
            //     }],
            //     backgroundColor: 'rgb(255, 99, 132)'
            // }]
            datasets.push(oneData)


            // console.log(datasets)

        } else {

            let promises = []

            if (chartType == 'line') {

                promises.push(new Promise((resolve, reject) => {

                    timeDateToDateFormat(info, 'value', timeUnit, (formated) => {
                        info = formated
                        // console.log(formated)
                        resolve()
                    }) //(formated) => {

                }))
            }
            mainPromises.push(new Promise((resolve, reject) => {

                Promise.all(promises).then(() => {
                    // console.log(info)
                    // for (const [key, value] of Object.entries(formated)) {

                    // formated.forEach(value => {

                    //     let labelIndex = labels.indexOf(value.x)
                    //     if (labelIndex == -1) {
                    //         labels.push(value.x)
                    //     }

                    // })


                    // labels = labels.sort(function (a, b) {
                    //     return a - b;
                    // })

                    // let color = this.getRandomColor()

                    // let oneData = {
                    //     label: "TEST",
                    //     backgroundColor: color,
                    //     borderColor: color,
                    //     data: [],
                    //     hoverOffset: 0,
                    //     align: 'left',


                    // }

                    // // for (const [key, value] of Object.entries(formated)) {

                    // formated.forEach(value => {
                    //     let labelIndex = labels.indexOf(value.x)
                    //     if (labelIndex != -1) {
                    //         oneData.data[labelIndex] = value.value
                    //     }
                    // })



                    // datasets.push(oneData)


                    // })
                    // info.forEach((element, index) => {
                    //     let labelIndex = labels.indexOf(element._id?.year)
                    //     if (labelIndex == -1) {
                    //         labels.push(element._id?.year)
                    //     }
                    // });


                    // } else {


                    info.forEach((element, index) => {

                        let colId = element?._id?.col?._id ?? element?._id?.col
                        let colLabel = colId

                        if (colField?.type == 'SelectInput') {
                            colLabel = getObject(element._id?.col, colField.information?.fields?.title)
                        }

                        let labelIndex = labels.indexOf(colLabel)
                        if (labelIndex == -1) {
                            labels.push(colLabel)
                        }
                    });

                    // console.log(labels)

                    labels = labels.sort(function (a, b) {
                        if (typeof a == 'number') {
                            return a - b
                        } else {
                            // console.log('a?', a)
                            // console.log('b?', b)
                            if (!a || a.trim() == '') {
                                return -1
                            }
                            if (!b || b.trim() == '') {
                                return 1
                            }
                            if (a?.toLowerCase() < b?.toLowerCase()) return -1;
                            if (a?.toLowerCase() > b?.toLowerCase()) return 1;
                        }
                        return 0;
                    })


                    let stacked

                    // console.log("groupBy", groupBy)
                    if (groupBy) {


                        stacked = info.reduce((item, { _id, value }) => {
                            let groupById = _id.groupBy?._id ?? _id.groupBy
                            let colId = _id.col?._id ?? _id.col
                            let colLabel = colId
                            let groupByLabel = groupById


                            if (colField.type == 'SelectInput') {
                                colLabel = getObject(_id?.col, colField.information?.fields?.title)
                            }

                            if (groupByField.type == 'SelectInput') {
                                groupByLabel = getObject(_id?.groupBy, groupByField.information?.fields?.title)
                            }

                            if (!item[groupByLabel]) item[groupByLabel] = {};
                            item[groupByLabel][colLabel] = value
                            return item;
                        }, {})
                    } else {

                        stacked = info.reduce((item, { _id, value }) => {

                            let colId = _id.col?._id ?? _id.col

                            if (!item.data) item.data = {};
                            item.data[colId ?? 'value'] = value
                            return item;
                        }, {})
                    }

                    // if (chartType == 'gauge') {
                    //     console.log("***, ", maxValue)
                    // }

                    // console.log(stacked)
                    let backGroundColors

                    if (chartType == 'pie' || chartType == 'polar' || chartType == 'funnel' || chartType == 'word') {
                        backGroundColors = []
                        labels.forEach(element => {
                            backGroundColors.push(this.getRandomColor())
                        });

                        // oneData.borderColor = '#fff'

                    }

                    for (const [key, value] of Object.entries(stacked)) {



                        // console.log(value)
                        let color = backGroundColors ?? this.getRandomColor()



                        let oneData = {
                            label: key,
                            backgroundColor: color,
                            borderColor: color,
                            maxValue: maxValue,
                            borderWidth: 0,
                            // hoverBackgroundColor: 'red',
                            // hoverBorderColor: 'black',
                            // hoverBorderWidth: '1',
                            // align: 'left',

                            // barThickness:Math.random() * 20,
                            data: []
                        }

                        if (chartType == 'word') {
                            oneData.color = color
                            oneData.hoverColor = '#000000aa'
                        }

                        if (chartType == 'line') {
                            oneData.borderWidth = 3
                        }

                        if (chartType == 'radar') {
                            oneData.borderWidth = 1
                        }

                        if (chartType == 'pie') {
                            oneData.borderWidth = 2
                            oneData.borderColor = '#fff'
                            oneData.hoverOffset = 10
                            oneData.borderRadius = 4
                            oneData.cutoutPercentage = 60
                        }

                        let max
                        let min


                        for (const [mkey, mvalue] of Object.entries(value)) {


                            let labelIndex = labels.indexOf(mkey)
                            if (labelIndex == -1) {
                                labelIndex = labels.indexOf(Number(mkey))
                            }
                            if (labelIndex != -1) {
                                oneData.data[labelIndex] = mvalue

                                if (max == null || mvalue > max) {
                                    max = mvalue
                                }

                                if (min == null || mvalue < min) {
                                    min = mvalue
                                }
                            }
                        }


                        if (chartType == 'word') {
                            let ratio = max / 120
                            oneData.data.forEach((element, index) => {
                                oneData.data[index] = oneData.data[index] / ratio
                            });
                        }


                        if (chartType == 'funnel') {
                            oneData.shrinkAnchor = 'top'

                            oneData.data = oneData.data.sort(function (a, b) {
                                return b - a;
                            })
                        }


                        // if (chartType == 'word') {
                        //     return
                        // }


                        // console.log("!!!",oneData)
                        datasets.push(oneData)


                    }


                    resolve()

                })
            }))




            // } else {

            //     let oneData = {
            //         label: "TEST",
            //         // backgroundColor: this.getRandomColor(),
            //         backgroundColor: this.createColorArray(info),//chroma.scale('Greens').colors(4),
            //         data: [],
            //         // align: 'left',
            //         shrinkAnchor: 'bottom', // For funnel 

            //     }

            //     info.forEach((element, index) => {
            //         let labelIndex = labels.indexOf(element._id?.col)
            //         if (labelIndex != -1) {
            //             oneData.data[labelIndex] = element.value //   /2000
            //         }
            //     })

            //     // oneData.data = oneData.data.sort(function (a, b) {
            //     //     return b - a;
            //     // }) // For funnel 


            //     datasets.push(oneData)



            // }
            // }

        }

        Promise.all(mainPromises).then(() => {

            // console.log(chartType)
            // console.log(labels)
            // console.log(datasets)

            this.setState({ show: false }, () => {


                this.createChartOption(() => {

                    currentData.data = { labels, datasets }
                    if (this.props.keepCurrentData) {
                        this.props.keepCurrentData(this.props.section, currentData)
                    }

                    // console.log(labels, datasets)

                    this.setState({ show: true, data: { labels, datasets } })
                })


            })

        })




    }


   


    randomValues = (count, min, max) => {
        const delta = max - min;
        return Array.from({ length: count }).map(() => Math.random() * delta + min);
    }


    colorize = (opaque, context) => {
        const value = context.raw;
        const x = value.x / 100;
        const y = value.y / 100;
        const r = this.channelValue(x, y, [250, 150, 50, 0]);
        const g = this.channelValue(x, y, [0, 50, 150, 250]);
        const b = this.channelValue(x, y, [0, 150, 150, 250]);
        const a = opaque ? 1 : 0.5 * value.v / 1000;

        return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
    }

    channelValue = (x, y, values) => {
        return x < 0 && y < 0 ? values[0] : x < 0 ? values[1] : y < 0 ? values[2] : values[3];
    }



    createColorArray = (data) => {

        let list = []

        data.forEach(element => {
            list.push(this.getRandomColor())
        });

        return list


    }


    createChartOption = (cb) => {

        let data = this.props.data

        let chartType = this.props.header?.information?.type
        let chartStyle = this.props.header?.information?.style
        let timeUnit = this.props.header?.information?.timeUnit ?? 'year,month'

        let indexAxis = 'x'
        let indexAxis_rev = 'y'

        let stacked = false

        if (chartStyle && chartStyle.includes('horizontal')) {
            indexAxis = 'y'
            indexAxis_rev = 'x'
        }

        if (chartStyle && chartStyle.includes('stacked')) {
            stacked = true
        }

        let fields = []
        if (this.props.frame) {
            fields = adminPages[this.props.frame].headers
        }
        let colField
        let groupByField
        let valueField

        if (Array.isArray(fields)) {

            for (let i = 0; i < fields.length; i++) {
                const field = fields[i];

                if (data.x_axis && field.key == data.x_axis) {
                    colField = field
                }

                if (data.groupBy && field.key == data.groupBy) {
                    groupByField = field
                }

                if (data.value && field.key == data.value) {
                    valueField = field
                }

            }
        }


        let chartOptions = {
            responsive: true,
            aspectRatio: 2 / 1,
            // cutoutPercentage: 60,
            // indexAxis: 'y',

            // datasets: {
            //     pie: {
            //         borderWidth:0
            //     }
            // },
            // borderWidth: 1,
            borderColor: "#eee",
            sort: 'desc' // Funnel
        }

        // chartOptions.global  = {responsive :false}


        chartOptions.plugins = {

            datalabels: {
                display: false
            },

            legend: {
                position: 'bottom',
                align: "start",
                labels: {
                    usePointStyle: true,
                    boxWidth: 6,
                    padding: 10,
                    // generateLabels: (chart) => {
                    //     const datasets = chart.data.datasets;
                    //     return datasets[0].data.map((data, i) => ({
                    //         text: `${chart.data.labels[i]} ${data}`,
                    //         fillStyle: datasets[0].backgroundColor[i],
                    //         index: i
                    //     }))
                    // }
                    // color: 'rgb(255, 99, 132)'

                }
            },




            tooltip: {
                enabled: true,
                // position: 'nearest',
                // external: function (context) {
                //     console.log("HERE")
                //     externalTooltipHandler(context)
                // }

            }

            // tooltip:{
            //     backgroundColor:'#ffffffee',
            //     titleColor:'#000',
            //     bodyColor:'#000000'

            // }
            // title: {
            //     display: true,
            //     text: 'Chart.js Horizontal Bar Chart'
            // }
        }


        chartOptions.animation = {

            duration: 0
            //     // onComplete: (chart)=> {

            //     //     console.log(chart)
            //     //     let ctx = chart.chart.ctx;
            //     //     // ctx.font = chart.scales?.font;
            //     //     // ctx.fillStyle = chart.scales?.textColor
            //     //     ctx.textAlign = "center";
            //     //     ctx.textBaseline = "bottom";

            //     //     this.state.data?.datasets.forEach(function (dataset) {
            //     //         console.log(dataset)
            //     //         dataset.lines.forEach(function (bar) {
            //     //             console.log(bar)
            //     //             ctx.fillText(bar.value, bar.x, bar.y - 5);
            //     //         });
            //     //     })
            //     // },
        }


        chartOptions.elements = {
            point: {
                radius: 5 // Scatter
                // radius: 0 // Line

            }
        }

        if (chartType == 'funnel') {
            chartOptions.indexAxis = 'y'
        }


        if (chartType == 'word') {
            chartOptions.maxRotation = 0 // Word
            chartOptions.minRotation = 0// Word
            // chartOptions.fit = true// Word
            chartOptions.randomness = 0// Word
            // chartOptions.color ='#ee5050'
        }

        if (chartType == 'matrix') {
            chartOptions.column = data.x_axis
            chartOptions.row = data.groupBy

        }

        if (chartType == 'table') {
            chartOptions.headers = []

            chartOptions.headers.push(colField)
            chartOptions.headers.push({ key: 'value', type: 'TextInput', information: { label: checkTranslation(data?.valueTitle) ?? translate('value') } })

        }

        if (chartType) {

            if (chartType == 'bar' || chartType == 'line') {


                chartOptions.scales = {

                    x: {
                        id: 'x',

                        // type: 'category',


                        // type: 'time',
                        // time: {
                        //     unit: 'month',
                        //     tooltipFormat: 'MMMM',
                        //     // displayFormats:'MMM / YY',
                        //     displayFormats: {
                        //         // quarter: 'MMM YYYY',
                        //         // month:"MMM"
                        //     }

                        // },

                        //     // stacked: true,
                        //     // grouped:true,
                        //     grid: {
                        //         color: "rgba(0, 0, 0, 0)",
                        //         display: false,
                        //         drawOnChartArea: false
                        //     },

                        ticks: {
                            maxRotation: 90,
                            beginAtZero: true,
                            fontColor: '#afafaf',
                            fontSize: 12,
                            minStats: 'whiskerMin',
                            // padding: 34 // For image

                            // maxTicksLimit:10

                        },

                    },



                    y: {
                        id: 'y',
                        // type: 'linear',
                        display: true,
                        // grouped:true,

                        // stacked: true, // For line this should be false

                        position: 'left',
                        ticks: {
                            minStats: 'whiskerMin',
                            beginAtZero: true,
                            fontColor: '#afafaf',
                            fontSize: 12,
                            // callback: function (value, index, values) {
                            //     return Number((value / 1000).toString()) + 'K';
                            // }
                        },

                        grid: {
                            color: '#00000010',
                        },

                    }
                    // {
                    //     type: 'linear',
                    //     display: true,
                    //     position: 'right',
                    //     id: 'y-axis-2',
                    //     gridLines: {
                    //         drawOnArea: false,
                    //     },
                    // },
                    // {
                    //     // type: 'linear',
                    //     display: true,
                    //     position: 'right',
                    //     id: 'y-axis-3',
                    //     gridLines: {
                    //         drawOnArea: false,
                    //     },
                }


                chartOptions.indexAxis = indexAxis


                if (stacked) {
                    chartOptions.scales[indexAxis].stacked = true
                    chartOptions.scales[indexAxis_rev].stacked = true
                }

                chartOptions.scales[indexAxis_rev].grid = {
                    color: "rgba(0, 0, 0, 0)",
                    display: false,
                    drawOnChartArea: false
                }


                // chartOptions.scales[indexAxis].type = 'category'


            }

            if (chartType == 'line') {

                let timeStyle
                if (!(timeUnit == 'quarter' || timeUnit == 'dayOfMonth' || timeUnit == 'dayOfWeek' || timeUnit == 'month' || timeUnit == 'week')) {
                    timeStyle = {
                        unit: 'quarter',
                        tooltipFormat: 'YYYY [Q]Q',
                        // displayFormats:'MMM / YY',
                        displayFormats: {
                            quarter: 'YYYY [Q]Q',
                            // month:"MMM"
                        }

                    }
                }

                chartOptions.scales = {

                    x: {
                        id: 'x',
                        // type: timeStyle ? 'time' : null,
                        // time: timeStyle,

                        ticks: {
                            maxRotation: 90,
                            beginAtZero: true,
                            fontColor: '#afafaf',
                            fontSize: 12,
                            // padding: 34 // For image
                            // maxTicksLimit:10

                        },

                    },



                    y: {
                        id: 'y',
                        display: true,
                        position: 'left',
                        ticks: {
                            minStats: 'whiskerMin',
                            beginAtZero: true,
                            fontColor: '#afafaf',
                            fontSize: 12,
                            // callback: function (value, index, values) {
                            //     return Number((value / 1000).toString()) + 'K';
                            // }
                        },

                        grid: {
                            color: '#00000010',
                        },

                    }

                }

                if (timeStyle) {

                    chartOptions.scales[indexAxis].type = 'time'
                    chartOptions.scales[indexAxis].time = timeStyle
                }

                // chartOptions.elements.bar = { borderWidth: 20 }
                chartOptions.elements.point = {
                    radius: 0,
                    // pointStyle:'rectRot' 
                }



            }

            if (chartType == 'radar') {
                chartOptions.elements.point = {
                    radius: 0,
                }
            }

            if (chartType == 'line' || chartType == 'radar' || chartType == 'word') {

                chartOptions.interaction = {
                    mode: 'nearest',
                    // axis: 'x',
                    intersect: false
                }
            }







            // chartOptions.animation = {

            //     // duration: 0
            //     // onComplete: (chart)=> {

            //     //     console.log(chart)
            //     //     let ctx = chart.chart.ctx;
            //     //     // ctx.font = chart.scales?.font;
            //     //     // ctx.fillStyle = chart.scales?.textColor
            //     //     ctx.textAlign = "center";
            //     //     ctx.textBaseline = "bottom";

            //     //     this.state.data?.datasets.forEach(function (dataset) {
            //     //         console.log(dataset)
            //     //         dataset.lines.forEach(function (bar) {
            //     //             console.log(bar)
            //     //             ctx.fillText(bar.value, bar.x, bar.y - 5);
            //     //         });
            //     //     })
            //     // },
            // }




            // rotation: -90,
            // circumference: 180,
            // cutoutPercentage: 95,

            // layout:{
            //     padding:{
            //         left:30
            //     }
            // },


            // chartOptions.maxBarThickness = 10
            // chartOptions.borderRadius = 10
            // chartOptions.borderSkipped = false




        }


        this.setState({ chartOptions }, () => {
            cb()
        })
    }


    getRandomColor(opacity) {
        // const letters = '0123456789ABCDEF';
        // let color = '#';
        // for (let i = 0; i < 6; i++) {
        //   color += letters[Math.floor(Math.random() * 16)];
        // }

        let colors = ["#ea5545", "#f46a9b", "#ef9b20", "#edbf33", "#ede15b", "#bdcf32", "#87bc45", "#27aeef", "#b33dc6"]

        let color = colors[Math.floor(Math.random() * colors.length)];

        return color + (opacity ?? 'aa');


    }

    render() {

        // console.log('this.props.header?.information?.type', this.props.header?.information?.type)

        let chartType = this.props.header?.information?.type ?? this.props.chartType

        const chartStyle = {
            width: '180px',
            height: '180px',
            position: 'relative',
        };

        const sliceStyle = {
            position: 'absolute',
            width: '100%',
            height: '100%',
            clipPath: 'polygon(50% 50%, 100% 0, 100% 100%)',
        };

        const slice1Style = {
            ...sliceStyle,
            backgroundColor: '#dedede',
            transform: 'rotate(0deg)',
            borderRadius: '50%'

        };

        const slice2Style = {
            ...sliceStyle,
            backgroundColor: '#c6c6c6',
            transform: 'rotate(45deg)',
            borderRadius: '50%'

        };

        const slice3Style = {
            ...sliceStyle,
            backgroundColor: '#8a8a8a',
            transform: 'rotate(135deg)',
            borderRadius: '50%'

        };

        const slice4Style = {
            ...sliceStyle,
            backgroundColor: '#efefef',
            transform: 'rotate(180deg)',
            borderRadius: '50%'

        };

        return (
            <div className={'h-100'}>

                <div className="w-100 h-100" ref={el => this.chartContainer = el}>



                    {this.state.show && (
                        <>

                       
                            <div className="dashboard-widgets h-100 d-flex flex-column">

                                <div className=' pt-3 d-flex position-sticky pb-2 px-3' style={{ justifyContent: 'space-between' }}>

                                  

                                   
                                </div>


                                <div className="px-3 pb-4 flex-1 flexcc" style={{}}>


                                    {(!chartType) && (
                                        <div className='position-relative mld-3' style={chartStyle}>
                                            <div className='position-absolute' style={{ width: 105, height: 105, backgroundColor: '#fff', borderRadius: "50%", top: "22%", left: "21%", zIndex: 1 }}></div>
                                            <div style={slice1Style}></div>
                                            <div style={slice2Style}></div>
                                            <div style={slice3Style}></div>
                                            <div style={slice2Style}></div>
                                            <div style={slice4Style}></div>
                                        </div>
                                    )}

                                  

                                    {chartType == 'line' && (

                                        <Line
                                            data={this.state.data}
                                            height={this.props.height}
                                            options={this.state.chartOptions}
                                            ref={el => this.chart = el}
                                        // plugins={[ChartDataLabels]}
                                        />

                                    )}
                                    {/* {console.log('this.state.dataCha', this.state.data)} */}
                                    {chartType == 'pie' && (

                                        <Pie
                                            data={this.state.data}
                                            height={this.props.height}
                                            options={this.state.chartOptions}
                                            ref={el => this.chart = el}
                                        />

                                    )}

                                    {chartType == 'doughnut' && (

                                        <Doughnut
                                            data={this.state.data}
                                            height={this.props.height}
                                            options={this.state.chartOptions}
                                            ref={el => this.chart = el}
                                        />

                                    )}

                                    {chartType == 'scatter' && (

                                        <Scatter
                                            data={this.state.data}
                                            height={this.props.height}
                                            options={this.state.chartOptions}
                                            ref={el => this.chart = el}
                                        />

                                    )}

                                    {chartType == 'bar' && (

                                        <Bar
                                            data={this.state.data}
                                            height={this.props.height}
                                            options={this.state.chartOptions}
                                            ref={el => this.chart = el}
                                        // plugins={[this.imagePlugin]}
                                        />

                                    )}

                                  

                                    {chartType == 'radar' && (

                                        <Radar
                                            data={this.state.data}
                                            height={this.props.height}
                                            options={this.state.chartOptions}
                                            ref={el => this.chart = el}
                                        />

                                    )}

                                    {chartType == 'polar' && (

                                        <PolarArea
                                            data={this.state.data}
                                            height={this.props.height}
                                            options={this.state.chartOptions}
                                            ref={el => this.chart = el}
                                        />

                                    )}

                                  

                                    {chartType == 'treemap' && (

                                        <Treemap
                                            data={this.state.data}
                                            height={this.props.height}
                                            options={this.state.chartOptions}
                                            ref={el => this.chart = el}
                                        />

                                    )}

                                    {chartType == 'word' && Array.isArray(this.state.data?.datasets) && this.state.data?.datasets.length > 0 && (

                                        <Wordmap
                                            data={this.state.data}
                                            height={this.props.height}
                                            options={this.state.chartOptions}
                                            ref={el => this.chart = el}
                                        />

                                    )}


                                    {chartType == 'funnel' && (

                                        <Funnelmap
                                            data={this.state.data}
                                            height={this.props.height}
                                            options={this.state.chartOptions}
                                            ref={el => this.chart = el}
                                        />

                                    )}



                                    {chartType == 'boxPlot' && (

                                        <BoxPlot
                                            data={this.state.data}
                                            height={this.props.height}
                                            options={this.state.chartOptions}
                                            ref={el => this.chart = el}
                                        />

                                    )}





                                    {chartType == 'gauge' && (

                                        <GaugeWidget
                                            value={80}
                                            data={this.state.data}
                                            height={this.props.height}
                                            options={this.state.chartOptions}
                                            ref={el => this.chart = el}
                                        />

                                    )}



                                    {chartType == 'matrix' && Array.isArray(this.state.data?.datasets) && this.state.data?.datasets.length > 0 && (
                                        <Matrix
                                            data={this.state.data?.datasets}
                                            height={this.props.height}
                                            options={this.state.chartOptions}
                                            ref={el => this.chart = el}
                                            headers={adminPages[this.props.frame].headers}
                                            width={this.state.width}
                                        />

                                    )}


                                    {chartType == 'table' && Array.isArray(this.state.data?.datasets) && this.state.data?.datasets.length > 0 && (
                                        <TableViewer
                                            data={this.state.data?.datasets}
                                            // height={this.props.height}
                                            // options={this.state.chartOptions}
                                            ref={el => this.chart = el}
                                            headers={this.state.chartOptions?.headers}
                                            width={this.state.width}
                                        />

                                    )}

                                    {/* {console.log(this.state.data?.datasets)}
                                    {console.log(this.state.chartOptions?.headers)} */}


                                </div>

                            </div>
                        </>
                    )}
                    {/*s<button className="text-smaller" style={{ color: '#007aff' }} onClick={() => this.changeZoomDirection()}>Reset Zoom</button> */}


                </div>
            </div>
        )
    }
}



async function timeDateToDateFormat(data, mykey, timeKey, cb) {

    // if (type == 'day') {
    //     type = "dayOfMonth"

    // }
    let tempgrouped = []
    let labels

    let refLables = {
        quarter: ['Q1', 'Q2', 'Q3', 'Q4'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        dayOfWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        week: [],
    }

    // console.log("HERE!!!!-")
    // console.log(timeKey)

    if (timeKey == 'quarter' || timeKey == 'dayOfMonth' || timeKey == 'dayOfWeek' || timeKey == 'month' || timeKey == 'week') {


        // console.log("HERE!!!!*")

        if (timeKey == 'week') {
            for (let i = 0; i <= 52; i++) {
                refLables.week.push(`${translate('Week')} ${i + 1}`)
            }
        }

        labels = refLables[timeKey]

        // console.log("labels, ", labels)


        labels.forEach((label, labelIndex) => {

            tempgrouped[labelIndex] = { _id: { col: label } }
            data.forEach(oneData => {


                if ((isNaN(oneData._id[timeKey]) && oneData._id[timeKey].toLowerCase() == label.toLowerCase()) || oneData._id[timeKey] == (labelIndex + 1)) {

                    let groupById = tempgrouped[labelIndex]._id.groupBy?._id ?? tempgrouped[labelIndex]._id.groupBy
                    tempgrouped[labelIndex].value = oneData.value
                    tempgrouped[labelIndex]._id[groupById] = oneData._id?.[groupById]

                }
            })
        })



    } else {



        let timeKeys = timeKey.split(',')
        // console.log(timeKeys)
        // console.log(mykey)

        let dateKeys = { 'year': "YYYY", quarter: "Q", 'month': 'MM', 'week': "W", 'dayOfMonth': "DD" }
        // let dateKeys = ['YYYY', 'MM', 'W', 'DD']
        // console.log(mykey)

        // let keyIndex = keys.indexOf(type)
        // console.log(keyIndex)
        // console.log(type)
        // console.log("data:::", data);


        for (let i = 0; i < data.length; i++) {
            const a = data[i];
            let r = {}
            let key = ''
            let timeKey = ''
            for (let i = 0; i < timeKeys.length; i++) {
                const element = timeKeys[i];
                // console.log(element)
                key = key + (i != 0 ? ' ' : '') + a._id[element]
                timeKey = timeKey + (i != 0 ? ' ' : '') + dateKeys[element]

            }

            let time = moment(key, timeKey).valueOf()

            let groupById = a._id?.groupBy?._id ?? a._id?.groupBy

            r[time] = r[time] || { [mykey]: 0, _id: { col: time, groupBy: groupById } }
            r[time][mykey] = Number((getObject(a, mykey)).toFixed(2))

            tempgrouped.push(Object.values(r)[0])


        }

        // tempgrouped = await data.reduce(function (r, a) {
        //     let key = ''
        //     let timeKey = ''
        //     for (let i = 0; i < timeKeys.length; i++) {
        //         const element = timeKeys[i];
        //         // console.log(element)
        //         key = key + (i != 0 ? ' ' : '') + a._id[element]
        //         timeKey = timeKey + (i != 0 ? ' ' : '') + dateKeys[element]

        //     }
        //     // console.log(key)
        //     // console.log(timeKey)
        //     let time = moment(key, timeKey).valueOf()

        //     // console.log(key)
        //     // console.log(time)
        //     // let time = moment([a._id.year, (keyIndex > 1 ? a._id.month : 1), (keyIndex > 2 ? a._id.dayOfMonth : 1)])
        //     // if (keyIndex == 2) {
        //     //     time = moment(a._id.year + " " + a._id.week, "YYYY W").valueOf()
        //     // }
        //     // console.log(moment(a._id.year + " "+a._id.month +" "+ a._id.week, "YYYY MM W").valueOf())


        //     // console.log(time)
        //     r[time] = r[time] || { [mykey]: 0, _id: { col: time, groupBy: a._id?.groupBy } }
        //     //   r[time][mykey] = Number((r[time][mykey] + a.count).toFixed(2))
        //     r[time][mykey] = Number((getObject(a, mykey)).toFixed(2))
        //     // console.log(key)

        //     return r




        //     // r[a._id] = r[a.categoryInfo._id] || { value: 0, title: a.categoryInfo.values.name };
        //     // r[a.categoryInfo._id].value = r[a.categoryInfo._id].value + a.value;
        //     // return r;
        // }, Object.create(null));

        // grouped = { ...grouped, ...tempgrouped }

        // console.log(grouped)

        tempgrouped = Object.values(tempgrouped)
        // console.log(tempgrouped)
        // console.log(tempgrouped.length)
        // console.log(data.length)


    }

    cb(tempgrouped)


}



function Treemap(props) {
    const treeCanvas = useRef(null);
    useEffect(() => {
        const chart = new ChartJS(treeCanvas.current, {
            type: "treemap",
            data: props.data,
            options: props.options
        });
        return () => chart.destroy();
    }, [treeCanvas, props]);
    return (
        <div>
            <canvas ref={treeCanvas} />
        </div>
    );
}





function BoxPlot(props) {
    const boxCanvas = useRef(null);
    useEffect(() => {

        // console.log(props)
        const chart = new ChartJS(boxCanvas.current, {
            type: 'boxplot',
            data: props.data,
            options: props.options
        });
        return () => chart.destroy();
    }, [boxCanvas, props.data]);
    return (
        <div>
            <canvas ref={boxCanvas} />
        </div>
    );
}


function Funnelmap(props) {
    const funnelCanvas = useRef(null);
    useEffect(() => {

        // console.log(props)
        const chart = new ChartJS(funnelCanvas.current, {
            type: 'funnel',
            data: props.data,
            options: props.options
        });
        return () => chart.destroy();
    }, [funnelCanvas, props.data]);
    return (
        <div>
            <canvas ref={funnelCanvas} />
        </div>
    );
}





function Wordmap(props) {
    const wordCanvas = useRef(null);
    useEffect(() => {
        if (wordCanvas) {
            setTimeout(() => {
                // console.log(wordCanvas)
                const chart = new ChartJS(wordCanvas.current, {
                    type: WordCloudController.id,
                    data: props.data,
                    options: props.options
                })
                return () => chart.destroy();
            }, 200);

        }
    }, [wordCanvas, props.data, props.options]);
    return (
        <div className="w-100 " >
            <canvas ref={wordCanvas} className="h-100 w-100" />
        </div>
    );
}




const getOrCreateTooltip = (chart) => {
    let tooltipEl = chart.canvas.parentNode.querySelector('div');

    if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.style.background = 'rgba(0, 0, 0, 0.7)';
        tooltipEl.style.borderRadius = '3px';
        tooltipEl.style.color = 'white';
        tooltipEl.style.opacity = 1;
        tooltipEl.style.pointerEvents = 'none';
        tooltipEl.style.position = 'absolute';
        tooltipEl.style.transform = 'translate(-50%, 0)';
        tooltipEl.style.transition = 'all .1s ease';

        const table = document.createElement('table');
        table.style.margin = '0px';

        tooltipEl.appendChild(table);
        chart.canvas.parentNode.appendChild(tooltipEl);
    }

    return tooltipEl;
};

const externalTooltipHandler = (context) => {

    // console.log("externalTooltipHandler")
    // console.log(context)

    // Tooltip Element
    const { chart, tooltip } = context;
    const tooltipEl = getOrCreateTooltip(chart);

    // Hide if no tooltip
    if (tooltip.opacity === 0) {
        tooltipEl.style.opacity = 0;
        return;
    }

    // Set Text
    if (tooltip.body) {
        const titleLines = tooltip.title || [];
        const bodyLines = tooltip.body.map(b => b.lines);

        const tableHead = document.createElement('thead');

        titleLines.forEach(title => {
            const tr = document.createElement('tr');
            tr.style.borderWidth = 0;

            const th = document.createElement('th');
            th.style.borderWidth = 0;
            const text = document.createTextNode(title);

            th.appendChild(text);
            tr.appendChild(th);
            tableHead.appendChild(tr);
        });

        const tableBody = document.createElement('tbody');
        bodyLines.forEach((body, i) => {
            const colors = tooltip.labelColors[i];

            const span = document.createElement('span');
            span.style.background = colors.backgroundColor;
            span.style.borderColor = colors.borderColor;
            span.style.borderWidth = '2px';
            span.style.marginRight = '10px';
            span.style.height = '10px';
            span.style.width = '10px';
            span.style.display = 'inline-block';

            const tr = document.createElement('tr');
            tr.style.backgroundColor = 'inherit';
            tr.style.borderWidth = 0;

            const td = document.createElement('td');
            td.style.borderWidth = 0;

            const text = document.createTextNode(body);

            td.appendChild(span);
            td.appendChild(text);
            tr.appendChild(td);
            tableBody.appendChild(tr);
        });

        const tableRoot = tooltipEl.querySelector('table');

        // Remove old children
        while (tableRoot.firstChild) {
            tableRoot.firstChild.remove();
        }

        // Add new children
        tableRoot.appendChild(tableHead);
        tableRoot.appendChild(tableBody);
    }

    const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

    // Display, position, and set styles for font
    tooltipEl.style.opacity = 1;
    tooltipEl.style.left = positionX + tooltip.caretX + 'px';
    tooltipEl.style.top = positionY + tooltip.caretY + 'px';
    tooltipEl.style.font = tooltip.options.bodyFont.string;
    tooltipEl.style.padding = tooltip.options.padding + 'px ' + tooltip.options.padding + 'px';
};



export default Chart;

